import l from '../../../../../lang';

export const hideFieldsByCountry = {
  BR: ['beneficiaryAddress'],
  ES: ['accountType', 'beneficiaryAddress', 'beneficiaryCity'],
  US: ['beneficiaryCity'],
  PE: ['beneficiaryAddress', 'bankBranch'],
  AR: ['beneficiaryAddress', 'bankBranch'],
  CR: ['bankCode', 'bankBranch'],
  CO: ['bankBranch'],
  MX: ['beneficiaryAddress', 'bankBranch'],
};

export const bankAccountNumberLabels = {
  PE: 'CCI *',
  MX: 'CLABE *',
  AR: 'CBU / CVU *',
  CR: 'IBAN *',
  PY: 'SIPAP *',
  ES: 'IBAN *',
};

export const bankBranchLabels = {
  ES: l('beneficiary.swiftCode'),
  US: l('beneficiary.routingNumber'),
};
